import { Component, ElementRef, HostListener, OnInit, ViewChild, inject } from '@angular/core';
import { AmdocsUserService, AmdocsAuthService, AmdocsEventBusService } from 'amdocs-core-package';
import { AvatarImgSize } from '../../../shared/avatar/avatar.component';
import jwt_decode from 'jwt-decode';
import { UserService } from "../../../service/user.service"
import { filter, finalize, Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { menuModel } from './model/menu.model';
import { CONSTANTS } from 'src/app/constants';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public menuList: menuModel[] = [{ routerLink: '', isActive: true, linkName: 'Home', type: 'inside' }];
  public employeeName: string = '';
  public avatarImgSize = AvatarImgSize;
  public showLoader: boolean = false;
  public showLogoff: boolean = false;
  public routerSubscription: Subscription;
  public activeUrl: string = '';
  @ViewChild('outsideClick', { static: true }) outsideClick: ElementRef;

  private amdocsUserService = inject(AmdocsUserService);
  private authService = inject(AmdocsAuthService);
  private eventBus = inject(AmdocsEventBusService);
  private user = inject(UserService);
  private router = inject(Router);

  constructor() {
    let formattedToken: any = '';
    if (jwt_decode(this.authService.getToken())) {
      formattedToken = jwt_decode(this.authService.getToken());
      this.employeeName = formattedToken.name ? formattedToken.name : '';
    }
    this.isHomePage();

  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.outsideClick && !this.outsideClick.nativeElement.contains(event.target)) {
      this.showLogoff = false; // Perform the necessary action
    }
  }

  isHomePage(): boolean {
    return this.router.url === '/';
  }

  ngOnInit(): void {
    this.menuList.push({
      routerLink: environment.headerConfig.supportOne,
      isActive: false,
      linkName: 'SupportONE',
      type: 'outside'
    })
    this.getHome();
  }

  getHome() {
    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.activeUrl = event.urlAfterRedirects;
    });
  }

  routeToModule(link: string, type: string) {
    if (type == 'inside') {
      this.menuList.find((x: { routerLink: string; }) => x.routerLink == link).isActive = true;
      this.menuList.find((x: { routerLink: string; }) => x.routerLink !== link).isActive = false;
      this.router.navigate([link], { replaceUrl: true });
      this.setStatisticsData(CONSTANTS.STATISTICS.SaveUserActivity,'HomeNavigation');
      
    } else {
        this.setStatisticsData(CONSTANTS.STATISTICS.SaveUserActivity,'SupportONE');
        window.open(link);
    }
  }

  setStatisticsData(actionType: string, eventType: string): void {
    console.log(this.user);
    const statisticsData = {
      actionType: CONSTANTS.STATISTICS.HeaderClick,
      landingPage:CONSTANTS.STATISTICS.Home,
      eventType: CONSTANTS.STATISTICS.Activity,
    };
    const statsData = this.user.getStatsticsInput(statisticsData);
    this.user.saveUserActivity(statsData);

  }

  getUserShortName(name): string {
    return this.amdocsUserService.getUserShortName(name);
  }

  openLink(link: any, type: any) {
    if (type == 'inside') {
      this.router.navigate(['/'], { replaceUrl: true });
    } else {
      window.open(link);
    }
  }

  showLogoutDrwaer(): void {
    this.showLogoff = !this.showLogoff;
  }


  onLogout(): void {
    this.showLoader = true;
    sessionStorage.clear();
    this.authService
      .logout()
      .pipe(
        finalize(() => {

        })
      )
      .subscribe(resp => {
        this.showLoader = false;
      });
  }

  openNewLink() {
    this.setStatisticsData(CONSTANTS.STATISTICS.SaveUserActivity,'HomeNavigation');
    this.router.navigate(['/'], { replaceUrl: true });
  }

  get name(): string {
    return this.user.getName();
  }

  get empId(): string {
    return this.user.getEmpId();
  }
}
